import {
  accountingModule,
  AppsPermissions,
  cateringModulePermission,
  employeeModule,
  inventoryModule,
  marketingModule,
  menuManagerModule,
  paymentModule,
  roleAndPermissionsModule,
  settingsModule,
  tipsModule,
  websiteModule,
} from '../DashboardModule/modulepermissions';
import { orderHubPosModule, paymentPosModule, tableLayoutPosModule } from '../PosModules/moduleFeatures';

export const defaultShiftAssistanceManager = [
  {
    id: 910,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 911,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: null,
    key: 'my-restaurant-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 912,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 913,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 914,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 915,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 916,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 917,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 918,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 919,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 920,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 921,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 922,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 923,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 924,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 925,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 926,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 927,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 928,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 929,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 930,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 931,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 932,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 933,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 934,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 935,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 936,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 937,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 938,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 939,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 940,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 941,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 942,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 943,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 944,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 945,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 946,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 947,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 948,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 949,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 950,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 951,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 952,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 31,
    key: 'own-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 953,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 954,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 34,
    key: 'release-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 955,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 956,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 118,
    key: 'release-manager-approval-required-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 957,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 119,
    key: 'bid-on-open-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 958,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 959,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 960,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 86,
    key: 'can-be-assigned-a-task-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 961,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 962,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 963,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 964,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 965,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 966,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 967,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 968,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 969,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 970,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 971,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 972,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 973,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 974,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 975,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 976,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 132,
    key: 'view-own-paystubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1471,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1472,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1473,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1474,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1475,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1476,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: null,
    key: 'header-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1477,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1478,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: null,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1479,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1480,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 45,
    key: 'login-without-clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1481,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 46,
    key: 'device-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1482,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1483,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 47,
    key: 'table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1484,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 48,
    key: 'table-status-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1485,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 49,
    key: 'switch-floors-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1486,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 15,
    featureId: 50,
    key: 'view-seating-capacity-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1487,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 16,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1488,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 55,
    key: 'service-charges-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1489,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 56,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1490,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1491,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1492,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1493,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1494,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 18,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1495,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 62,
    key: 'settings-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1496,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 63,
    key: 'orders-hub-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1497,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 64,
    key: 'restaurant-type-hamburger-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1498,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 65,
    key: 'cashdrawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1499,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 19,
    featureId: 66,
    key: 'aio-help-center-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1500,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 67,
    key: 'my-day-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1501,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 68,
    key: 'overview-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1502,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 69,
    key: 'z-report-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1503,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1504,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 71,
    key: 'other-stations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1505,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 72,
    key: 'my-station-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1506,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 73,
    key: 'host-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1507,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 74,
    key: 'logs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1508,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 75,
    key: 'adjust-starting-balance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1509,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 21,
    featureId: 76,
    key: 'close-drawer-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1510,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 26,
    key: 'refund-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1511,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1512,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 43,
    featureId: 54,
    key: 'adjust-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1635,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1636,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1637,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: null,
    key: 'table-layout-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1638,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: null,
    key: 'menu-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1639,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: null,
    key: 'ticket-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1640,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1641,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 23,
    featureId: 78,
    key: 'other-tables-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1642,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 51,
    key: 'comp-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1643,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 79,
    key: 'void-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1644,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 24,
    featureId: 80,
    key: 'edit-service-charge-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1645,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 57,
    key: 'tax-exempt-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1646,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 58,
    key: 'change-table-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1647,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 59,
    key: 'change-server-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1648,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 60,
    key: 'void-order-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1649,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 61,
    key: 'discounts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1650,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 25,
    featureId: 81,
    key: 'custom-item-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1838,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: null,
    featureId: null,
    key: 'web-dash-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1839,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 17,
    featureId: null,
    key: 'payments-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1840,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 26,
    featureId: null,
    key: 'restaurant-&-location-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1841,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 27,
    featureId: null,
    key: 'menu-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1842,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 28,
    featureId: null,
    key: 'marketing-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1843,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1844,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 97,
    key: 'sales-tax-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1845,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1846,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 98,
    key: 'comps-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1847,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1848,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 17,
    featureId: 99,
    key: 'service-charge-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1849,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 26,
    featureId: 83,
    key: 'restaurant-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1850,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 26,
    featureId: 83,
    key: 'restaurant-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1851,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 26,
    featureId: 84,
    key: 'location-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1852,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 26,
    featureId: 84,
    key: 'location-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1853,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1854,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 90,
    key: 'menu-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1855,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1856,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 91,
    key: 'category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1857,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1858,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 92,
    key: 'Item-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1859,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1860,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 93,
    key: 'modifier-group-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1861,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1862,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 94,
    key: 'modifier-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1863,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1864,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 95,
    key: 'modifier-option-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1865,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1866,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 27,
    featureId: 96,
    key: 'tags-&-allergens-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1867,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1868,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 100,
    key: 'guestbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1869,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1870,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 101,
    key: 'brandbook-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1871,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1872,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 102,
    key: 'deals-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1873,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1874,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 103,
    key: 'website-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1875,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1876,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 104,
    key: 'spotlights-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1877,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1878,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 105,
    key: 'campaigns-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1879,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1880,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 106,
    key: 'journeys-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1881,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1882,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 107,
    key: 'loyalty-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1883,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1884,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 108,
    key: 'dashboard-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1885,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1886,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 109,
    key: 'gift-cards-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1995,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1996,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 139,
    key: 'guest-segments-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2003,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2004,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 28,
    featureId: 140,
    key: 'guest-spend-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2007,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 45,
    featureId: null,
    key: 'integrations-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2011,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 45,
    featureId: null,
    key: 'integrations-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 2019,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 28,
    featureId: 141,
    key: 'review-management-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3217,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 4,
    moduleId: 29,
    featureId: null,
    key: 'inventory-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3266,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3267,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3268,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3269,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 148,
    key: 'ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3270,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3271,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3272,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3273,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 149,
    key: 'orders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3274,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3275,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3276,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3277,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 150,
    key: 'recipes-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3278,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3279,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3280,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3281,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 151,
    key: 'invoices-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3282,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3283,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3284,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3285,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 152,
    key: 'storage-areas-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3286,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3287,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3288,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3289,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 153,
    key: 'vendors-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3290,
    roleId: 13,
    userId: null,
    permissionId: 1,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3291,
    roleId: 13,
    userId: null,
    permissionId: 4,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3292,
    roleId: 13,
    userId: null,
    permissionId: 2,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3293,
    roleId: 13,
    userId: null,
    permissionId: 3,
    appId: 4,
    moduleId: 29,
    featureId: 154,
    key: 'non-ingredients-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3483,
    roleId: 13,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 43,
    featureId: 53,
    key: 'update-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const shiftAssistantManagerDashboardPermissions = [
  AppsPermissions['web-dash-visible'],
  paymentModule['payments-visible'],
  menuManagerModule['menu-manager-visible'],
  marketingModule['marketing-visible'],
  inventoryModule['inventory-visible'],
  accountingModule['accounting-visible'],
  websiteModule['website-visible'],
  tipsModule['tips-management-visible'],
  paymentModule['sales-tax-visible'],
  paymentModule['sales-tax-read'],
  paymentModule['sales-tax-edit'],
  paymentModule['comps-visible'],
  paymentModule['comps-read'],
  paymentModule['comps-edit'],
  paymentModule['service-charge-visible'],
  paymentModule['service-charge-read'],
  paymentModule['service-charge-edit'],
  paymentModule['tenders-visible'],
  paymentModule['tenders-read'],
  paymentModule['tenders-edit'],
  paymentModule['cash-drawer-visible'],
  paymentModule['cash-drawer-read'],
  paymentModule['cash-drawer-edit'],
  menuManagerModule['menu-visible'],
  menuManagerModule['menu-read'],
  menuManagerModule['menu-edit'],
  menuManagerModule['category-visible'],
  menuManagerModule['category-read'],
  menuManagerModule['category-edit'],
  menuManagerModule['Item-visible'],
  menuManagerModule['Item-read'],
  menuManagerModule['Item-edit'],
  menuManagerModule['modifier-group-visible'],
  menuManagerModule['modifier-group-read'],
  menuManagerModule['modifier-group-edit'],
  menuManagerModule['modifier-visible'],
  menuManagerModule['modifier-read'],
  menuManagerModule['modifier-edit'],
  menuManagerModule['modifier-option-visible'],
  menuManagerModule['modifier-option-read'],
  menuManagerModule['modifier-option-edit'],
  menuManagerModule['tags-&-allergens-visible'],
  menuManagerModule['tags-&-allergens-read'],
  menuManagerModule['tags-&-allergens-edit'],
  marketingModule['guestbook-visible'],
  marketingModule['guestbook-read'],
  marketingModule['guestbook-edit'],
  marketingModule['brandbook-visible'],
  marketingModule['brandbook-read'],
  marketingModule['brandbook-edit'],
  marketingModule['deals-visible'],
  marketingModule['deals-read'],
  marketingModule['deals-edit'],
  marketingModule['website-visible'],
  marketingModule['website-read'],
  marketingModule['website-edit'],
  marketingModule['spotlights-visible'],
  marketingModule['spotlights-read'],
  marketingModule['spotlights-edit'],
  marketingModule['campaigns-visible'],
  marketingModule['campaigns-read'],
  marketingModule['campaigns-edit'],
  marketingModule['journeys-visible'],
  marketingModule['journeys-read'],
  marketingModule['journeys-edit'],
  marketingModule['loyalty-visible'],
  marketingModule['loyalty-read'],
  marketingModule['loyalty-edit'],
  marketingModule['dashboard-visible'],
  marketingModule['dashboard-read'],
  marketingModule['dashboard-edit'],
  marketingModule['gift-cards-visible'],
  marketingModule['gift-cards-read'],
  marketingModule['gift-cards-edit'],
  marketingModule['guest-segments-visible'],
  marketingModule['guest-segments-read'],
  marketingModule['guest-segments-edit'],
  marketingModule['guest-spend-visible'],
  marketingModule['guest-spend-read'],
  marketingModule['guest-spend-edit'],
  marketingModule['review-management-visible'],
  marketingModule['review-management-read'],
  marketingModule['review-management-edit'],
  inventoryModule['ingredients-visible'],
  inventoryModule['ingredients-read'],
  inventoryModule['ingredients-edit'],
  inventoryModule['orders-visible'],
  inventoryModule['orders-read'],
  inventoryModule['orders-edit'],
  inventoryModule['recipes-visible'],
  inventoryModule['recipes-read'],
  inventoryModule['recipes-edit'],
  inventoryModule['invoices-visible'],
  inventoryModule['invoices-read'],
  inventoryModule['invoices-edit'],
  inventoryModule['storage-areas-visible'],
  inventoryModule['storage-areas-read'],
  inventoryModule['storage-areas-edit'],
  inventoryModule['vendors-visible'],
  inventoryModule['vendors-read'],
  inventoryModule['vendors-edit'],
  inventoryModule['non-ingredients-visible'],
  inventoryModule['non-ingredients-read'],
  inventoryModule['non-ingredients-edit'],
  accountingModule['chart-of-accounts-visible'],
  accountingModule['chart-of-accounts-read'],
  accountingModule['bill-payments-visible'],
  accountingModule['bill-payments-read'],
  accountingModule['journal-entry-visible'],
  accountingModule['journal-entry-read'],
  accountingModule['sales-controller-visible'],
  accountingModule['sales-controller-read'],
  websiteModule['website-templates-visible'],
  websiteModule['website-templates-edit'],
  websiteModule['website-templates-read'],
  websiteModule['website-builder-visible'],
  websiteModule['website-builder-read'],
  websiteModule['website-builder-edit'],
  websiteModule['website-seo-visible'],
  websiteModule['website-seo-read'],
  websiteModule['website-seo-edit'],
  websiteModule['website-announcements-visible'],
  websiteModule['website-announcements-read'],
  websiteModule['website-announcements-edit'],
  tipsModule['tips-pooling-visible'],
  tipsModule['tips-pooling-read'],
  tipsModule['tips-pooling-edit'],
  roleAndPermissionsModule['roles-permissions-visible-module'],
  roleAndPermissionsModule['roles-permissions-visible'],
  roleAndPermissionsModule['roles-permissions-read'],
  roleAndPermissionsModule['roles-permissions-edit'],
  employeeModule['employee-management-visible'],
  employeeModule['employees-visible'],
  employeeModule['employees-read'],
  employeeModule['employees-edit'],
  settingsModule['settings-visible'],
  settingsModule['receipt-settings-visible'],
  settingsModule['receipt-settings-read'],
  settingsModule['receipt-settings-edit'],
  settingsModule['business-hours-visible'],
  settingsModule['business-hours-read'],
  settingsModule['business-hours-edit'],
];

export const shiftAssistantManagerDefaultPosPermission = [
  tableLayoutPosModule['assign-server-visible'],
  paymentPosModule['tenders-visible'],
  orderHubPosModule['order-hub-visible'],
  orderHubPosModule['ticket-visible'],
];

export const shiftAssistantManagerDefaultWebDashNewFeaturePermission = [
  websiteModule['forms-visible'],
  websiteModule['forms-read'],
  websiteModule['forms-edit'],
  websiteModule['overview-visible'],
  websiteModule['overview-read'],
  websiteModule['overview-edit'],
];
export const shiftAssistantDefaultCateringFeaturePermission = [
  cateringModulePermission['catering-visible'],
  cateringModulePermission['dashboard-create'],
  cateringModulePermission['dashboard-read'],
  cateringModulePermission['dashboard-edit'],
  cateringModulePermission['invoice-management-read'],
  cateringModulePermission['package-configuration-create'],
  cateringModulePermission['package-configuration-read'],
  cateringModulePermission['package-configuration-edit'],
  cateringModulePermission['email-templates-read'],
];
export const cateringRemainingFeaturesPermissionsforShiftAssistance = [
  cateringModulePermission['payment-configuration-visible'],
  cateringModulePermission['payment-configuration-create'],
  cateringModulePermission['payment-configuration-read'],
  cateringModulePermission['payment-configuration-edit'],
  cateringModulePermission['email-inbox-visible'],
  cateringModulePermission['email-inbox-create'],
  cateringModulePermission['email-inbox-read'],
  cateringModulePermission['email-inbox-edit'],
  cateringModulePermission['calendar-visible'],
  cateringModulePermission['calendar-create'],
  cateringModulePermission['calendar-read'],
  cateringModulePermission['calendar-edit'],
];
